export const queryKey = {
    comments: () => ['comments'],
};
